import { Table } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import { EntityGroupPicker } from '@work4all/components/lib/components/entity-picker/entity-group-picker/EntityGroupPicker';

import { Category } from '@work4all/models/lib/Classes/Category.entity';
import { Group } from '@work4all/models/lib/Classes/Group.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { useLeftAreaVisibleFiltersState } from '../../../../hooks/use-left-area-visible-filters';
import { PersonalAndGeneralViewV8 } from '../../../filters/PersonalAndGeneralView/v8';
import { ProjectCategoryPicker } from '../../../filters/ProjectCategoryPicker';
import {
  TableQuickFilters,
  TableQuickFiltersSection,
  TableQuickFiltersSectionHeader,
} from '../../table-quick-filters';
import { createHandleColumnFilterChange } from '../../table-quick-filters/utils';

export function ProjectTableQuickFilters({ table }: { table: Table<unknown> }) {
  const { t } = useTranslation();

  const columns = {
    group: table.getColumn('groupId'),
    categories: table.getColumn('categoryAssignmentList.categoryId'),
    closed: table.getColumn('groprojectStatus.closedStatusupId'),
  };

  const groups = (columns.group?.getFilterValue() as any)?.value ?? null;
  const handleGroupsChange = createHandleColumnFilterChange<Group>(
    columns.group
  );

  const categories =
    (columns.categories?.getFilterValue() as any)?.value ?? null;

  const handleCategoriesChange = createHandleColumnFilterChange<Category>(
    columns.categories
  );

  const { isFilterVisible } = useLeftAreaVisibleFiltersState({
    entity: Entities.project,
    filterIds: ['personal', 'general'],
  });

  return (
    <TableQuickFilters>
      <TableQuickFiltersSection>
        <TableQuickFiltersSectionHeader>
          {t('COMMON.GROUPS')}
        </TableQuickFiltersSectionHeader>
        <EntityGroupPicker
          entity={Entities.projectGroup}
          value={groups}
          onChange={handleGroupsChange}
        />
      </TableQuickFiltersSection>

      <TableQuickFiltersSection>
        <TableQuickFiltersSectionHeader>
          {t('COMMON.CATEGORIES')}
        </TableQuickFiltersSectionHeader>
        <ProjectCategoryPicker
          value={categories}
          onChange={handleCategoriesChange}
        />
      </TableQuickFiltersSection>

      <PersonalAndGeneralViewV8
        value={groups ?? categories}
        entity={Entities.project}
        hidePersonalFilters={!isFilterVisible('personal')}
        hideGeneralFilters={!isFilterVisible('general')}
        table={table}
      />
    </TableQuickFilters>
  );
}
